export const PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_FAIL = "PRODUCT_LIST_FAIL";

export const PRODUCT_LISTSEARCH_REQUEST = "PRODUCT_LISTSEARCH_REQUEST";
export const PRODUCT_LISTSEARCH_SUCCESS = "PRODUCT_LISTSEARCH_SUCCESS";
export const PRODUCT_LISTSEARCH_FAIL = "PRODUCT_LISTSEARCH_FAIL";

export const PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST";
export const PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS";
export const PRODUCT_DETAILS_FAIL = "PRODUCT_DETAILS_FAIL";

export const PRODUCT_CATEGORY_REQUEST = "PRODUCT_CATEGORY_REQUEST";
export const PRODUCT_CATEGORY_SUCCESS = "PRODUCT_CATEGORY_SUCCESS";
export const PRODUCT_CATEGORY_FAIL = "PRODUCT_CATEGORY_FAIL";
